<script lang="ts">
  import { link, Link } from "svelte-routing"
  import {
    currentChainId,
    pairListSelectedOrder,
    pairListSelectedCategories,
    pairCount,
    pairsLoadDone,
    pairs,
    pairListCurrentOffset,
    pairListIsEndReached,
    uploadDone,
  } from "../stores/store"
  import ListFilter from "../components/ListFilter.svelte"
  import ListCard from "../components/ListCard.svelte"
  import {
    Container,
    Row,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Spinner,
  } from "sveltestrap"
  import InfiniteScroll from "svelte-infinite-scroll";
  import { ORDER_BY } from "../stores/constants"
  import { getCount, getPairCount, getPairList, getPairs } from "../stores/query"
  import { query } from "@urql/svelte"
  import { convertPairData } from "../utils/utils"
  import { onMount } from "svelte"

  let isLoading = false;

  const convertAndConcatFetchedList = (page, reset) => {
    reset = reset === true;
    const convertPromises = page.map((elem) => {
      return convertPairData($currentChainId, elem);
    })
    Promise.allSettled(convertPromises).then(res => {
      isLoading = false;
      if (reset) {
        pairs.set(res.filter(e => e.status === 'fulfilled').map(e => e.value));
      } else {
        pairs.set($pairs.concat(res.filter(e => e.status === 'fulfilled').map(e => e.value)));
      }
    })
  }

  const fetchData = (reset) => {
    if (reset === true) {
      pairListIsEndReached.set(false);
      pairListCurrentOffset.set(0);
    }
    const data = {
      offset: $pairListCurrentOffset,
      orderBy: ORDER_BY[$pairListSelectedOrder].orderBy,
      orderDirection: ORDER_BY[$pairListSelectedOrder].orderDirection,
    };
    if ($pairListSelectedCategories.length > 0) {
      data['category'] = $pairListSelectedCategories;
    }
    if ($pairListIsEndReached || isLoading) {
      return;
    }
    isLoading = true;
    if ($uploadDone) {
      uploadDone.set(false);
    }
    getPairList($currentChainId, data).then(res => {
      if (res.pairs.length === 0) {
        pairListIsEndReached.set(true);
      }
      convertAndConcatFetchedList(res.pairs, reset);
      pairListCurrentOffset.update(n => n + 9);
    }).catch(e => {console.log(e); isLoading= false;});
  }

  const fetchCount = () => {
    const data = $pairListSelectedCategories.length > 0 ? {category: $pairListSelectedCategories} : {};
    getPairCount($currentChainId, data).then(res => {
      let count = 0;
      res.categoryCounts.map(e => count += e.pairCount);
      pairCount.set(count);
    }).catch(console.error);
  }

  onMount(() => {
    if ($pairs.length === 0 || $uploadDone) {
      fetchData(true);
      fetchCount();
    }
  });

  const selectOrder = (i: number) => {
    return () => {
      pairListIsEndReached.set(false);
      pairListCurrentOffset.set(0);
      pairListSelectedOrder.set(i);
      fetchCount();
      fetchData(true);
    }
  }

  const removeCategory = () => {
    pairListSelectedCategories.set([]);
    pairListIsEndReached.set(false);
    pairListCurrentOffset.set(0);
    fetchData(true);
    fetchCount();
  };

  const selectCategory = (category) => {
    pairListSelectedCategories.set([category]);
    pairListIsEndReached.set(false);
    pairListCurrentOffset.set(0);
    fetchData(true);
    fetchCount();
  };

</script>

<Container>
  <Row class="align-items-center nft-list-header" cols={{ xs: 1, sm: 2 }}>
    <Col class="search-result">
      Search results · {$pairCount} items
    </Col>
    <Col class="filter-mobile">
      <ListFilter isMobile={true} selectedCategories={$pairListSelectedCategories} {removeCategory} {selectCategory} />
    </Col>
    <Col class="justify-content-end">
      <Row class="align-items-center text-end gx-3">
        <Col class="sort-by">
          Sort by
        </Col>
        <Col class="sort-by-toggle-col col-auto">
          <Dropdown class="">
            <DropdownToggle caret class="sort-by-toggle">
              {ORDER_BY[$pairListSelectedOrder].description}&nbsp;
              <i class="ri-arrow-down-s-line icon-small"></i>
            </DropdownToggle>
            <DropdownMenu>
              {#each Object.keys(ORDER_BY) as i}
                <DropdownItem on:click={selectOrder(i)}>{ORDER_BY[i].description}</DropdownItem>
              {/each}
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
    </Col>
  </Row>
  <Row>
    <Col xs="12" sm="3">
      <ListFilter isMobile={false} selectedCategories={$pairListSelectedCategories} {removeCategory} {selectCategory} />
    </Col>
    <Col xs="12" sm="9">
      <Row cols={{ xs: 1, sm: 1, md: 2, lg: 3 }}>
        {#each $pairs as pair}
          <ListCard pair={pair} />
        {/each}
      </Row>
      {#if isLoading}
      <div class="spinner-div"><Spinner light size="lg" /></div>
      {/if}
    </Col>
  </Row>
  <InfiniteScroll threshold={10} on:loadMore={fetchData} window={true} />
</Container>

<style>
  .spinner-div {
      margin-top: 30px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  }
</style>
